import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "@/store/reducers";
import createSagaMiddleware from "redux-saga";
import sagas from "@/store/sagas/index";
import { appHistory } from "@/common/other/appHistory";

const sagaMiddleware = createSagaMiddleware();

const appStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // redux-saga dispatches non-serializable actions (channel objects, etc.)
      // and many of our existing actions carry class instances.
      serializableCheck: false,
    }).concat(sagaMiddleware),
  // RTK enables DevTools automatically in development builds.
});

sagaMiddleware.run(sagas, { history: appHistory });

// Infer types from the store itself — these will eventually replace
// the hand-written Store type once all reducers are migrated.
export type RootState = ReturnType<typeof appStore.getState>;
export type AppDispatch = typeof appStore.dispatch;

export default appStore;
